<template>
  <div class="title-bar">
      <slot name='icon'/>
      <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
}
</script>

<style lang='scss'>
.title-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(16, 77, 144, 1);
  height: 40px;
  color: rgba(255, 255, 255, 1);
  span {
    margin-left: 10px;
  }
}
</style>